const ALLOWED_LIMITS = new Set([20, 40, 100]);

export const normalizeTableContentPaging = (limit, offset) => {
  const normalizedLimit = ALLOWED_LIMITS.has(Number(limit)) ? Number(limit) : 20;
  const offsetNumber = Number(offset);
  const normalizedOffset = Number.isFinite(offsetNumber) && offsetNumber > 0 ? offsetNumber : 0;
  return { limit: normalizedLimit, offset: normalizedOffset };
};

export const isTableContentEnd = ({ offset = 0, rowCount = 0, totalCount = 0 }) =>
  Number(offset) + Number(rowCount) >= Number(totalCount);

export const getNextOffset = ({ offset = 0, limit = 20 }) => Number(offset) + Number(limit);

export const getPrevOffset = ({ offset = 0, limit = 20 }) => Math.max(0, Number(offset) - Number(limit));
